import React from "react";
import { connect } from "react-redux";
import MMPLShipCard from "./MMPLShipCard";
import { getMDSearchlist } from "../Actions/MDlistingAPI";
import "react-datepicker/dist/react-datepicker.css";
import {
  getShipPO,
  getMMPLShipCount,
  getMMPLShipSearch,
  getClients,
  getClientSearchResult,
  getClientLists,
  getShipnameListByClientEmail,
} from "../Actions/MMPLDashboardAPI";
import ShipPOs from "./ShipPOs";
import Moment from "moment";
import CountUp from "react-countup";
import swal from "sweetalert";
import Autocomplete from "react-autocomplete";
import { getShipnameList } from "../Actions/HelpersAPI";
import { GetKPIData } from "../Actions/CommonAPI";
import { ExportExcelShip } from "../Actions/ShipViewAPI";
import axios from "axios";
import API from "../helpers/api";
import PO from "../Asset/PO.svg";
import MyPendingTask from "../Asset/MyPendingTask.svg";
import Awaiting from "../Asset/Awaiting.svg";
import ShipPendingTask from "../Asset/ShipPendingTask.svg";
import IHMPending from "../Asset/IHMPending.svg";
import IHMUpdated from "../Asset/IHMUpdated.svg";
import shortClosed from "../Asset/shortClosed.svg";
import Ship from "../Asset/Ship.svg";
import clear from "../Asset/clear.svg";
import * as $ from "jquery";
import { ThemeConsumer } from "react-bootstrap/esm/ThemeProvider";

class MMPLDashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      initialSearch: 1,
      initialClientSearch: 1,
      filterTitle: "All Ships",
      showPendingTask: false,
      searchShip: {
        ShipName: "",
        PageSize: 25,
      },
      searchClients: {
        ClientName: "",
        ShipName: "",
        clientSearchResult: [],
      },
      PageNo: 1,
      PgSize: 25,
      EquipmentList: [],
      shipId: 0,
      shipName: "",
      poValidationShipName: "",
      poValidationIMONo: "",
      isShortClosed: false,
      isIhmPart1: false,
      isAwaitingMdAndSdoc: false,
      isPoValidation: false,
      isShipsPendingTask: false,
      isIhmUpdate2: false,
      isPurchaseOrders: true,
      TotalShip: false,
      shipSuccess: false,
      ClientList: [],
      ShipList: [],
      clientId: "",
    };
    this.handleSelectChange = this.handleSelectChange.bind(this);
    this.handleInputChanges = this.handleInputChanges.bind(this);
    this.renderMovieTitle = this.renderMovieTitle.bind(this);
    this.SearchShipPOs = this.SearchShipPOs.bind(this);
    this.getShipDetails = this.getShipDetails.bind(this);
    this.SearchShips = this.SearchShips.bind(this);
    this.ClearShipSearchField = this.ClearShipSearchField.bind(this);
  }

  componentDidMount() {
    localStorage.removeItem("shipName")
    const { dispatch, SearchResult, match } = this.props;
    dispatch({ type: "POSuccess", data: "" });
    dispatch({ type: "SubBannerTitle", data: "Dashboard" });
    let user = JSON.parse(localStorage.getItem("currentUser"));

    let url = `${API.MMPLShipCount}?mmplMail=${user.email}&shipId=${this.state.shipId}`;
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "GetMMPLShipCountSuccess",
          data: response.data,
        });
        dispatch(getClients());
        dispatch(getShipnameList());
        dispatch(getShipnameListByClientEmail(""));
        dispatch(GetKPIData());
        //dispatch(getClientLists(this.state));
        dispatch(getClientSearchResult(this.state));
      })
      .catch((error) => {
        dispatch({
          type: "GetMMPLShipCountFailure",
          error: "ERROR",
        });
      });
    // dispatch(getMMPLShipCount(this.state.shipId));
    if (SearchResult) {
      dispatch(getShipPO(SearchResult, SearchResult.PageNo));
    } else {
      dispatch({
        type: "GetShipPOsSuccess",
        data: [],
      });
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const {
      dispatch,
      ShipNameList,
      SearchResult,
      ClientList,
      ShipList,
      clientSearchResult,
    } = nextProps;
    if (nextProps.isMDSearch && nextProps.showSidePane) {
      prevState.searchShip = nextProps.MDSearchData;
    }
    if (nextProps.MDDeleteSuccess && !nextProps.showSidePane) {
      prevState.searchShip = nextProps.MDSearchData;
      dispatch(getMDSearchlist(prevState.searchShip));
    }
    if (ShipNameList) {
      prevState.EquipmentList = ShipNameList;
    }
    if (clientSearchResult) {
      prevState.searchClients.clientSearchResult = clientSearchResult;
    }
    if (ClientList) {
      prevState.ClientList = ClientList;
    }
    if (ShipList) {
      prevState.ShipList = ShipList;
    }
    if (SearchResult && SearchResult !== "" && !prevState.shipSuccess) {
      prevState.poValidationShipName = SearchResult.poValidationShipName;
      prevState.shipName = SearchResult.shipName;
      prevState.isPurchaseOrders = SearchResult.isPurchaseOrders;
      prevState.isShipsPendingTask = SearchResult.isShipsPendingTask;
      prevState.isIhmUpdate2 = SearchResult.isIhmUpdate2;
      prevState.isPoValidation = SearchResult.isPoValidation;
      prevState.isAwaitingMdAndSdoc = SearchResult.isAwaitingMdAndSdoc;
      prevState.isIhmPart1 = SearchResult.isIhmPart1;
      prevState.isShortClosed = SearchResult.isShortClosed;
      prevState.TotalShip = SearchResult.TotalShip;
      prevState.shipSuccess = true;
    }
  }

  MMPLDashboardClientNavigation = (e, clientId) => {
    this.props.dispatch({ type: "Otherpages" });
    this.setState({ show: false });
    this.props.dispatch({ type: "SubBannerTitle", data: "Dashboard" });
    this.props.history.push(`/Home/MMPLDashboardClient/${clientId}`);
    e.preventDefault();
  };

  getShipDetails(action) {
    const { dispatch } = this.props;
    this.state.initialSearch = 1;
    if (action === 1) {
      this.state.poValidationShipName = "";
      this.state.poValidationIMONo = "";
      this.state.shipName = "";
      this.state.isShortClosed = false;
      this.state.isShipsPendingTask = false;
      this.state.isIhmUpdate2 = false;
      this.state.isIhmPart1 = false;
      this.state.isAwaitingMdAndSdoc = false;
      this.state.isPoValidation = true;
      this.state.isPurchaseOrders = false;
      this.state.TotalShip = false;
      this.state.shipSuccess = false;
      dispatch({ type: "searchSuccess", data: "" });
      dispatch({ type: "MMPLSidePanCollectDocs", data: false });
      this.setState({});
      //window.scrollTo(0, document.body.scrollHeight);
      dispatch({
        type: "GetShipPOsSuccess",
        data: [],
      });
      // dispatch(getShipPO(this.state, this.state.PageNo));
    } else if (action === 2) {
      this.state.poValidationShipName = "";
      this.state.poValidationIMONo = "";
      this.state.shipName = "";
      this.state.isShortClosed = false;
      this.state.isShipsPendingTask = false;
      this.state.isIhmUpdate2 = false;
      this.state.isIhmPart1 = false;
      this.state.isAwaitingMdAndSdoc = true;
      this.state.isPoValidation = false;
      this.state.isPurchaseOrders = false;
      this.state.TotalShip = false;
      this.state.shipSuccess = false;
      dispatch({ type: "searchSuccess", data: "" });
      this.setState({});
      //window.scrollTo(0, document.body.scrollHeight);
      dispatch({
        type: "GetShipPOsSuccess",
        data: [],
      });
      // dispatch(getShipPO(this.state, this.state.PageNo));
    } else if (action === 3) {
      this.state.poValidationShipName = "";
      this.state.poValidationIMONo = "";
      this.state.shipName = "";
      this.state.isShortClosed = false;
      this.state.isShipsPendingTask = false;
      this.state.isIhmUpdate2 = false;
      this.state.isIhmPart1 = true;
      this.state.isAwaitingMdAndSdoc = false;
      this.state.isPoValidation = false;
      this.state.isPurchaseOrders = false;
      this.state.TotalShip = false;
      this.state.shipSuccess = false;
      dispatch({ type: "searchSuccess", data: "" });
      dispatch({ type: "MMPLSidePanCollectDocs", data: false });
      this.setState({});
      //window.scrollTo(0, document.body.scrollHeight);
      dispatch({
        type: "GetShipPOsSuccess",
        data: [],
      });
      // dispatch(getShipPO(this.state, this.state.PageNo));
    } else if (action === 4) {
      this.state.poValidationShipName = "";
      this.state.shipName = "";
      this.state.poValidationIMONo = "";
      this.state.isShortClosed = false;
      this.state.isShipsPendingTask = false;
      this.state.isIhmUpdate2 = false;
      this.state.isIhmPart1 = false;
      this.state.isAwaitingMdAndSdoc = false;
      this.state.isPoValidation = false;
      this.state.isPurchaseOrders = true;
      this.state.TotalShip = false;
      this.state.shipSuccess = false;
      dispatch({ type: "searchSuccess", data: "" });
      dispatch({ type: "PurchaseOrders", data: false });
      this.setState({});
      //window.scrollTo(0, document.body.scrollHeight);
      dispatch({
        type: "GetShipPOsSuccess",
        data: [],
      });
      // dispatch(getShipPO(this.state, this.state.PageNo));
    } else if (action === 5) {
      this.state.poValidationShipName = "";
      this.state.poValidationIMONo = "";
      this.state.shipName = "";
      this.state.isShortClosed = true;
      this.state.isShipsPendingTask = false;
      this.state.isIhmUpdate2 = false;
      this.state.isIhmPart1 = false;
      this.state.isAwaitingMdAndSdoc = false;
      this.state.isPoValidation = false;
      this.state.isPurchaseOrders = false;
      this.state.TotalShip = false;
      this.state.shipSuccess = false;
      dispatch({ type: "searchSuccess", data: "" });
      this.setState({});
      //window.scrollTo(0, document.body.scrollHeight);
      dispatch({
        type: "GetShipPOsSuccess",
        data: [],
      });
      // dispatch(getShipPO(this.state, this.state.PageNo));
    } else if (action === 6) {
      this.state.poValidationShipName = "";
      this.state.poValidationIMONo = "";
      this.state.shipName = "";
      this.state.isShortClosed = false;
      this.state.isShipsPendingTask = true;
      this.state.isIhmUpdate2 = false;
      this.state.isIhmPart1 = false;
      this.state.isAwaitingMdAndSdoc = false;
      this.state.isPoValidation = false;
      this.state.isPurchaseOrders = false;
      this.state.TotalShip = false;
      this.state.shipSuccess = false;
      dispatch({ type: "searchSuccess", data: "" });
      this.setState({});
      //window.scrollTo(0, document.body.scrollHeight);
      dispatch({
        type: "GetShipPOsSuccess",
        data: [],
      });
      // dispatch(getShipPO(this.state, this.state.PageNo));
    } else if (action === 7) {
      this.state.poValidationShipName = "";
      this.state.poValidationIMONo = "";
      this.state.shipName = "";
      this.state.isShortClosed = false;
      this.state.isShipsPendingTask = false;
      this.state.isIhmUpdate2 = true;
      this.state.isIhmPart1 = false;
      this.state.isAwaitingMdAndSdoc = false;
      this.state.isPoValidation = false;
      this.state.isPurchaseOrders = false;
      this.state.TotalShip = false;
      this.state.shipSuccess = false;
      dispatch({ type: "searchSuccess", data: "" });
      dispatch({ type: "MMPLSidePanCollectDocs", data: false });
      this.setState({});
      //window.scrollTo(0, document.body.scrollHeight);
      dispatch({
        type: "GetShipPOsSuccess",
        data: [],
      });
      // dispatch(getShipPO(this.state, this.state.PageNo));
    } else {
      this.state.poValidationShipName = "";
      this.state.poValidationIMONo = "";
      this.state.shipName = "";
      this.state.isShortClosed = false;
      this.state.isIhmPart1 = false;
      this.state.isShipsPendingTask = false;
      this.state.isIhmUpdate2 = false;
      this.state.isAwaitingMdAndSdoc = false;
      this.state.isPoValidation = false;
      this.state.isPurchaseOrders = false;
      this.state.TotalShip = true;
      this.state.shipSuccess = false;
      dispatch({ type: "searchSuccess", data: "" });
      dispatch({ type: "MMPLSidePanCollectDocs", data: false });
      this.setState({});
      //window.scrollTo(0, document.body.scrollHeight);
      this.props.dispatch({
        type: "getMMPLShipSearchSuccess",
        data: null,
      });
      // dispatch(getMMPLShipSearch(this.state, this.state.PageNo));
    }
    this.setState({ showClientDetails: false, filterclientDetails: false });
  }

  ClearPoSearchField() {
    $(
      "#poErrMsg,#poValidationErrMsg,#awaitingErrMsg,#ihmPart1ErrMsg,#imhUpdatedErrMsg,#scErrMsg,#pendingShipErrMsg"
    ).text("");
    this.state.initialSearch = 1;
    this.state.poValidationShipName = "";
    this.state.poValidationIMONo = "";
    this.props.dispatch({
      type: "GetShipPOsSuccess",
      data: [],
    });
    // this.props.dispatch(getShipPO(this.state, this.state.PageNo));
    this.setState({});
  }

  SearchShips(PgNo) {
    if (this.state.shipName == "") {
      $("#totalShipErrMsg").text("Please enter the ship name");
      return;
    } else {
      $("#totalShipErrMsg").text("");
    }
    const { dispatch } = this.props;
    dispatch(getMMPLShipSearch(this.state, PgNo));
  }

  ClearShipSearchField() {
    this.state.initialSearch = 1;
    this.state.shipName = "";
    $("#totalShipErrMsg").text("");
    this.props.dispatch({
      type: "getMMPLShipSearchSuccess",
      data: null,
    });
    // this.props.dispatch(getMMPLShipSearch(this.state, this.state.PageNo));
    this.setState({});
  }

  handleInputChange(e) {
    let nodeName = e.target.name;
    this.state[nodeName] = e.target.value;
    this.setState({});
  }

  handlePOInputChange(e) {
    this.state.poValidationShipName = e.target.value;
    this.setState({});
  }

  handleShipInputChange(e) {
    this.state.shipName = e.target.value;
    if (this.state.shipName == "") {
      $("#totalShipErrMsg").text("Please enter the ship name");
    } else {
      $("#totalShipErrMsg").text("");
    }
    this.setState({});
  }

  handleClientInputChange(e, str) {
    this.state.searchClients[str] = e.target.value;
    if (str == "ClientName") {
      this.setState({
        searchClients: { ClientName: e.target.value, ShipName: "" },
      });
      if (e.target.value == "") {
        this.props.dispatch(getShipnameListByClientEmail(""));
      } else {
        this.props.dispatch({
          type: "getshipByEmailSuccess",
          data: [],
        });
      }
    }
    this.setState({});
  }

  handleClientSelectChange(value, field, item) {
    const { dispatch } = this.props;
    this.state.searchClients[field] = value;
    if (this.state.searchClients.ClientName != "") {
      if (field == "ClientName") {
        dispatch(getShipnameListByClientEmail(item.clientEmail));
      }
    } else {
      dispatch(getShipnameListByClientEmail(""));
    }
    this.setState({});
  }

  SearchShipPOs(action, field) {
    if (field !== "povalidation") {
      if (this.state.poValidationShipName == "") {
        $(
          "#awaitingErrMsg,#ihmPart1ErrMsg,#imhUpdatedErrMsg,#scErrMsg,#pendingShipErrMsg"
        ).text("Please select the ship name");
        return;
      }
    }
    this.state.initialSearch = 0;
    const { dispatch } = this.props;
    dispatch(getShipPO(this.state));
  }

  SearchClients() {
    this.state.initialSearch = 1;
    this.state.initialClientSearch = 0;
    const { dispatch } = this.props;
    localStorage.setItem("shipName", JSON.stringify(this.state.searchClients.ShipName))
    dispatch(getClientSearchResult(this.state));
  }

  ClearClientsField() {
    const { dispatch } = this.props;
    const clear = {
      ClientName: "",
      ShipName: "",
      clientSearchResult: [],
    };
    this.setState({ searchClients: clear }, () => {
      dispatch(getClientSearchResult(this.state));
    });
  }

  renderMovieTitle(state, val) {
    return state.toLowerCase().indexOf(val.toLowerCase()) !== -1;
  }

  renderClientTitleObj(state, val) {
    return state?.clientName?.toLowerCase().indexOf(val.toLowerCase()) !== -1;
  }

  renderShipTitleObj(state, val) {
    return state?.shipName?.toLowerCase().indexOf(val.toLowerCase()) !== -1;
  }

  handleInputChanges(e, field) {
    const { dispatch } = this.props;
    this.state[field] = e.target.value;
    if (this.state.poValidationShipName != "") {
      $(
        "#poErrMsg,#poValidationErrMsg,#awaitingErrMsg,#ihmPart1ErrMsg,#imhUpdatedErrMsg,#scErrMsg,#pendingShipErrMsg"
      ).text("");
    }
    this.setState({});
  }

  handleSelectChange(value, field) {
    this.state[field] = value;
    if (this.state.poValidationShipName != "") {
      $(
        "#poErrMsg,#poValidationErrMsg,#awaitingErrMsg,#ihmPart1ErrMsg,#imhUpdatedErrMsg,#scErrMsg,#pendingShipErrMsg"
      ).text("");
    }
    this.setState({});
  }

  downloadAwaitingExcel = () => {
    const { dispatch } = this.props;
    dispatch(ExportExcelShip());
    this.setState({});
  };

  render() {
    const {
      shipMMPLInfo,
      equipmentInfo,
      MMPLSidePanCollectDocs,
      shipMMPLCount,
      MMPLShipList,
      ShipPO,
      ClientPOs,
      clientSearchResult,
    } = this.props;
    const {
      isShortClosed,
      isIhmPart1,
      isAwaitingMdAndSdoc,
      isPoValidation,
      isPurchaseOrders,
      TotalShip,
      PurchaseOrders,
      isShipsPendingTask,
      isIhmUpdate2,
    } = this.state;
    return (
      <div
        className="full-height pt-3 pb-1 my-4"
        style={{ backgroundColor: "#F1F5F9", borderRadius: 14 }}
      >
        <div className="mx-0 pt-2 px-4 row">
          {/* style={{ minWidth: "12.5%" }} */}
          <div
            className="col-lg-1 col-md-3 col-sm-6 p-1 pr-2 mb-4 "
            style={{ minWidth: "12.5%" }}
          >
            <div
              className={`${isPurchaseOrders ? "active-card " : "card-box "
                }card card-selector pl-4 pr-2 py-3 card-count`}
              onClick={() => this.getShipDetails(4)}
            >
              <img src={PO} width={24} height={24} />
              <div
                className={`${MMPLSidePanCollectDocs ? "f-2 " : " "} `}
                style={{
                  marginTop: 10,
                  color: "#F77F00",
                }}
              >
                <CountUp
                  start={0}
                  className="po-color"
                  end={shipMMPLCount ? shipMMPLCount.pOs : 0}
                  duration={2.0}
                  separator=","
                />
              </div>
              <div
                className={`${MMPLSidePanCollectDocs ? "f-1 " : " "
                  } mt-1 po-bcolor `}
              >
                Purchase Orders
              </div>
            </div>
            <div className="card-count-shadow"></div>
          </div>
          <div
            className="col-lg-1  col-md-3 col-sm-6 p-1 pr-2 mb-4"
            style={{ minWidth: "12.5%" }}
          >
            <div
              className={`${isPoValidation ? "active-card " : "card-box "
                }card card-selector pl-4 pr-2 py-3 card-count`}
              // style={{ height: "100%" }}
              onClick={() => this.getShipDetails(1)}
            >
              <img src={MyPendingTask} width={24} height={24} />
              <div
                className={`${MMPLSidePanCollectDocs ? "f-2 " : " "} `}
                style={{ marginTop: 10, color: "#D62828" }}
              >
                <CountUp
                  start={0}
                  className="po-color"
                  end={shipMMPLCount ? shipMMPLCount.poValidation : 0}
                  duration={2.0}
                  separator=","
                />
              </div>
              <div
                className={`${MMPLSidePanCollectDocs ? "f-1 " : " "
                  } mt-1 po-bcolor `}
              >
                My Pending Tasks - PO Validation
              </div>
            </div>
            <div className="card-count-shadow"></div>
          </div>
          <div
            className="col-lg-1 col-md-3 col-sm-6 p-1 pr-2  mb-4"
            style={{ minWidth: "12.5%" }}
          >
            <div
              className={`${isAwaitingMdAndSdoc ? "active-card " : "card-box "
                }card card-selector pl-4 pr-2 py-3 card-count`}
              style={{ height: "100%" }}
              onClick={() => this.getShipDetails(2)}
            >
              <img src={Awaiting} width={24} height={24} />
              <div
                className={`${MMPLSidePanCollectDocs ? "f-2 " : " "}`}
                style={{ marginTop: 10, color: "#F77F00" }}
              >
                <CountUp
                  start={0}
                  className="po-color"
                  end={shipMMPLCount ? shipMMPLCount.collectMdocSdoc : 0}
                  duration={2.0}
                  separator=","
                />
              </div>
              <div
                className={`${MMPLSidePanCollectDocs ? "f-1 " : " "
                  } mt-1 po-bcolor `}
              >
                Awaiting MD & SDoC
              </div>
            </div>
            <div className="card-count-shadow"></div>
          </div>
          <div
            className="col-lg-1  col-md-3 col-sm-6 p-1 pr-2  mb-4"
            style={{ minWidth: "12.5%" }}
          >
            <div
              className={`${isShipsPendingTask ? "active-card " : "card-box "
                }card card-selector pl-4 pr-2 py-3 card-count`}
              style={{ height: "100%" }}
              onClick={() => this.getShipDetails(6)}
            >
              <img src={ShipPendingTask} width={24} height={24} />
              <div
                className={`${MMPLSidePanCollectDocs ? "f-2 " : " "} `}
                style={{ marginTop: 10, color: "#D62828" }}
              >
                <CountUp
                  start={0}
                  className="po-color"
                  end={
                    shipMMPLCount
                      ? shipMMPLCount.shipsPendingTask
                        ? shipMMPLCount.shipsPendingTask
                        : 0
                      : 0
                  }
                  duration={2.0}
                  separator=","
                />
              </div>
              <div
                className={`${MMPLSidePanCollectDocs ? "f-1 " : " "
                  } mt-1 po-bcolor`}
              >
                Ships Pending Task
              </div>
            </div>
            <div className="card-count-shadow"></div>
          </div>
          <div
            className="col-lg-1  col-md-3 col-sm-6 p-1 pr-2  mb-4"
            style={{ minWidth: "12.5%" }}
          >
            <div
              className={`${isIhmPart1 ? "active-card " : "card-box "
                }card card-selector pl-4 pr-2 py-3 card-count`}
              style={{ height: "100%" }}
              onClick={() => this.getShipDetails(3)}
            >
              <img src={IHMPending} width={24} height={24} />
              <div
                className={`${MMPLSidePanCollectDocs ? "f-2 " : " "}`}
                style={{ marginTop: 10, color: "#F77F00" }}
              >
                <CountUp
                  start={0}
                  className="po-color"
                  end={shipMMPLCount ? shipMMPLCount.ihmPart1 : 0}
                  duration={2.0}
                  separator=","
                />
              </div>
              <div
                className={`${MMPLSidePanCollectDocs ? "f-1 " : " "
                  } mt-1 po-bcolor`}
              >
                {" "}
                IHM Part 1 - Pending to be Updated
              </div>
            </div>
            <div className="card-count-shadow"></div>
          </div>
          <div
            className="col-lg-1  col-md-3 col-sm-6 p-1 pr-2  mb-4"
            style={{ minWidth: "12.5%" }}
          >
            <div
              className={`${isIhmUpdate2 ? "active-card " : "card-box "
                }card card-selector pl-4 pr-2 py-3 card-count`}
              style={{ height: "100%" }}
              onClick={() => this.getShipDetails(7)}
            >
              <img src={IHMUpdated} width={24} height={24} />
              <div
                className={`${MMPLSidePanCollectDocs ? "f-2 " : " "}`}
                style={{ marginTop: 10, color: "#C5D86D" }}
              >
                <CountUp
                  start={0}
                  className="po-color"
                  end={shipMMPLCount ? shipMMPLCount.ihmUpdate2 : 0}
                  duration={2.0}
                  separator=","
                />
              </div>
              <div
                className={`${MMPLSidePanCollectDocs ? "f-1 " : " "
                  } mt-1 po-bcolor`}
              >
                {" "}
                IHM Part 1 - Updated
              </div>
            </div>
            <div className="card-count-shadow"></div>
          </div>
          <div
            className="col-lg-1  col-md-3 col-sm-6 p-1 pr-2  mb-4"
            style={{ minWidth: "12.5%" }}
          >
            <div
              className={`${isShortClosed ? "active-card " : "card-box "
                }card card-selector pl-4 pr-2 py-3 card-count`}
              style={{ height: "100%" }}
              onClick={() => this.getShipDetails(5)}
            >
              <img src={shortClosed} width={24} height={24} />
              <div
                className={`${MMPLSidePanCollectDocs ? "f-2 " : " "} `}
                style={{ marginTop: 10, color: "#86CD82" }}
              >
                <CountUp
                  start={0}
                  className="po-color"
                  end={shipMMPLCount ? shipMMPLCount.shortClosed : 0}
                  duration={2.0}
                  separator=","
                />
              </div>
              <div
                className={`${MMPLSidePanCollectDocs ? "f-1 " : " "
                  } mt-1 po-bcolor`}
              >
                {" "}
                Short Closed - PO's
              </div>
            </div>
            <div className="card-count-shadow"></div>
          </div>
          <div
            className="col-lg-1  col-md-3 col-sm-6 p-1 pr-2  mb-4"
            style={{ minWidth: "12.5%" }}
          >
            <div
              className={`${TotalShip ? "active-card " : "card-box "
                }card card-selector pl-4 pr-2 py-3 card-count`}
              style={{ height: "100%" }}
              onClick={() => this.getShipDetails("noAction")}
            >
              <img src={Ship} width={24} height={24} />
              <div
                className={`${MMPLSidePanCollectDocs ? "f-2 " : " "} `}
                style={{ marginTop: 10, color: "#685044" }}
              >
                <CountUp
                  start={0}
                  className="po-color"
                  end={shipMMPLCount ? shipMMPLCount.totalShips : 0}
                  duration={2.0}
                  separator=","
                />
              </div>
              <div
                className={`${MMPLSidePanCollectDocs ? "f-1 " : " "
                  } mt-1 po-bcolor`}
              >
                Total Ships
              </div>
            </div>
            <div className="card-count-shadow"></div>
          </div>
        </div>
        {/* <div className="px-4 pt-4"> */}
        <div className="pt-4 px-2 mx-1 row">
          <div className="col-xl-4 ">
            <label className="label-card pbm10px">Clients</label>
          </div>
          <div className="col-xl-8 my-auto">
            <div className="row pl-2 prd-4 mbm1rem">
              <div className="autocomplete-wrappers col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12 mb-3 pl-1 prd-3 prm-3">
                <Autocomplete
                  value={this.state.searchClients.ClientName}
                  items={this.state.ClientList}
                  getItemValue={(item) => item.clientName}
                  renderInput={(props) => {
                    return (
                      <input
                        className="form-control"
                        id="exampleFormControlInput23"
                        placeholder="Client Name"
                        {...props}
                        style={{ border: "1px solid #ffffff" }}
                      />
                    );
                  }}
                  shouldItemRender={this.renderClientTitleObj.bind(this)}
                  renderMenu={(item) => <div className="dropdowns">{item}</div>}
                  renderItem={(item, isHighlighted) => (
                    <div
                      className={`items ${isHighlighted ? "selected-items" : ""
                        }`}
                    >
                      {item.clientName}
                    </div>
                  )}
                  onChange={(e, field) =>
                    this.handleClientInputChange(e, "ClientName")
                  }
                  onSelect={(value, item) =>
                    this.handleClientSelectChange(value, "ClientName", item)
                  }
                />
              </div>

              <div className="autocomplete-wrappers col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12 mb-3 pl-1 prd-3 prm-3">
                <Autocomplete
                  value={this.state.searchClients.ShipName}
                  items={this.state.ShipList}
                  getItemValue={(item) => item}
                  renderInput={(props) => {
                    return (
                      <input
                        className="form-control"
                        id="exampleFormControlInput23"
                        placeholder="Ship Name"
                        {...props}
                        style={{ border: "1px solid #ffffff" }}
                      />
                    );
                  }}
                  shouldItemRender={this.renderMovieTitle.bind(this)}
                  renderMenu={(item) => <div className="dropdowns">{item}</div>}
                  renderItem={(item, isHighlighted) => (
                    <div
                      className={`items ${isHighlighted ? "selected-items" : ""
                        }`}
                    >
                      {item}
                    </div>
                  )}
                  onChange={(e, field) =>
                    this.handleClientInputChange(e, "ShipName")
                  }
                  onSelect={(value) =>
                    this.handleClientSelectChange(value, "ShipName")
                  }
                />
              </div>
              <div className="col-xl-2 col-lg-2 col-md-2 col-sm-6 col-6 px-1 mb-3">
                <button
                  className="btn btn-primary txtside-btn txtht-btn blue w-100 btnclr"
                  type="submit"
                  onClick={() => this.SearchClients()}
                >
                  {" "}
                  Search{" "}
                </button>
              </div>
              <div className="col-xl-2 col-lg-2 col-md-2 col-sm-6 col-6 px-1 mb-3">
                <button
                  className="btn txtside-btn txtht-btn w-100 clearbtn clr-butn"
                  onClick={() => this.ClearClientsField()}
                  type="button"
                >
                  <img className="mb-1" src={clear} width={21} height={21} />{" "}
                  Clear{" "}
                </button>
              </div>
            </div>
          </div>
        </div>

        {clientSearchResult && clientSearchResult.length > 0 ? (
          <div className=" mt-0 mb-4 ml-4 mr-4 cardBck row">
            <div className="col-xl-12 py-3">
              <div className="row px-3">
                {clientSearchResult.map((item, index) => {
                  return (
                    <>
                      <div
                        className="col-xl-3 col-lg-4 col-md-6 col-sm-12 col-12 p-2 cursor-pointer"
                        onClick={(e) =>
                          this.MMPLDashboardClientNavigation(e, item.clientId)
                        }
                      >
                        <div className="card ccard px-4 pt-3 h-100">
                          <div className="bold-count">{item.totalShips}</div>
                          <div className="bord-title pt-1">
                            {item.clientName}
                          </div>

                          <div
                            className="my-3"
                            style={{ border: "0.1px solid #EEEEEE" }}
                          ></div>
                          <div className="row">
                            <div className="sub-card pb-2 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">
                              Purchase Orders
                            </div>
                            <div className="subcard-count pb-2 col-xl-6  col-lg-6 col-md-6 col-sm-6 col-6">
                              {item.pos}
                            </div>
                          </div>
                          <div className="row">
                            <div className="sub-card py-2 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">
                              My Pending Tasks - PO Validation
                            </div>
                            <div className="subcard-count py-2 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">
                              {item.poConfirmations}
                            </div>
                          </div>
                          <div className="row">
                            <div className="sub-card py-2 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">
                              Awaiting MD & SDoC
                            </div>
                            <div className="subcard-count py-2 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">
                              {item.awaitingMdAndSdoc}
                            </div>
                          </div>
                          <div className="row">
                            <div className="sub-card py-2 col-xl-8  col-lg-8 col-md-8 col-sm-8 col-8">
                              Ships Pending Task
                            </div>
                            <div className="subcard-count py-2 col-xl-4  col-lg-4 col-md-4 col-sm-4 col-4">
                              {item.shipPendingTask}
                            </div>
                          </div>
                          <div className="row">
                            <div className="sub-card py-2 col-xl-9 pr-0  col-lg-9 col-md-9 col-sm-9 col-9">
                              IHM Part 1 - Pending to be Updated
                            </div>
                            <div className="subcard-count py-2 col-xl-3  col-lg-3 col-md-3 col-sm-3 col-3">
                              {item.ihmPart1ToBeUpdated}
                            </div>
                          </div>
                          <div className="row">
                            <div className="sub-card py-2 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">
                              IHM Part 1 - updated
                            </div>
                            <div className="subcard-count py-2 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">
                              {item.ihmPart1Updated}
                            </div>
                          </div>
                          <div className="row">
                            <div className="sub-card py-2 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">
                              Short Closed - PO’s
                            </div>
                            <div className="subcard-count py-2 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">
                              {item.shortClosed}
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  );
                })}
              </div>
            </div>
          </div>
        ) : this.state.initialClientSearch == 0 ? (
          <div className="mt-0 mb-4 ml-4 mr-4  cardBck row">
            <div className="col-xl-12">
              <h6 className="bold-count no-item-card f-size">No Clients</h6>
            </div>
          </div>
        ) : null}

        {/* ships */}

        {this.state.isPurchaseOrders ? (
          <>
            <div className="pt-3 px-2 mx-1 row">
              <div className="col-xl-4">
                <label className="label-card">Ships</label>
              </div>
              <div className="col-xl-8 my-auto">
                <div className="row pl-2 prd-4 mbm1rem">

                  <div className="autocomplete-wrappers col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12 mb-3 prd-3 pl-1  prm-3 ">
                    <Autocomplete
                      value={this.state.poValidationShipName}
                      items={this.state.EquipmentList}
                      getItemValue={(item) => item}
                      renderInput={(props) => {
                        return (
                          <input
                            className="form-control"
                            id="exampleFormControlInput1"
                            placeholder="Ship Name"
                            {...props}
                            style={{ border: "1px solid #ffffff" }}
                          />
                        );
                      }}
                      shouldItemRender={this.renderMovieTitle.bind(this)}
                      renderMenu={(item) => (
                        <div className="dropdowns">{item}</div>
                      )}
                      renderItem={(item, isHighlighted) => (
                        <div
                          className={`items ${isHighlighted ? "selected-items" : ""
                            }`}
                        >
                          {item}
                        </div>
                      )}
                      onChange={(e, field) =>
                        this.handleInputChanges(e, "poValidationShipName")
                      }
                      onSelect={(value) =>
                        this.handleSelectChange(value, "poValidationShipName")
                      }
                    />
                    <span id="poErrMsg" style={{ color: "red" }}></span>
                  </div>
                  <div className="autocomplete-wrappers col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12 mb-3 prd-3 pl-1  prm-3">
                    <input className="form-control" style={{ border: "1px solid white" }} type="text" name="poValidationIMONo" placeholder="IMO No" value={this.state.poValidationIMONo} onChange={(e, field) =>
                      this.handleInputChanges(e, "poValidationIMONo")
                    }></input>
                  </div>
                  <div className="col-xl-2 col-lg-2 col-md-2 col-sm-6 col-6 px-1 px-1 mb-3">
                    <button
                      className="btn btn-primary txtside-btn txtht-btn blue w-100 btnclr"
                      type="submit"
                      onClick={() => this.SearchShipPOs(1, "povalidation")}
                    >
                      {" "}
                      Search{" "}
                    </button>
                  </div>
                  <div className="col-xl-2 col-lg-2 col-md-2 col-sm-6 col-6 px-1 px-1 mb-3">
                    <button
                      className="btn txtside-btn txtht-btn w-100 clearbtn clr-butn"
                      type="button"
                      onClick={() => this.ClearPoSearchField()}
                    >
                      <img
                        className="mb-1"
                        src={clear}
                        width={21}
                        height={21}
                      />{" "}
                      Clear{" "}
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {ShipPO && ShipPO.length ? (
              <>
                <ShipPOs
                  arraylist={ShipPO}
                  setUpdatedState={(value) => this.SearchShipPOs(value)}
                />
              </>
            ) : this.state.initialSearch == 0 ? (
              <>
                <div className="mt-0 mb-4 ml-4 mr-4  cardBck row">
                  <div className="col-xl-12">
                    <h6 className="bold-count no-item-card f-size">No Ships</h6>
                  </div>
                </div>
                <div className="pb-1"></div>
              </>
            ) : null}
          </>
        ) : null}
        {this.state.isPoValidation ? (
          <>
            <div className="pt-3 px-2 mx-1 row">
              <div className="col-xl-4">
                <label className="label-card">Ships</label>
              </div>
              <div className="col-xl-8 my-auto">
                <div className="row pl-2 prd-4 mbm1rem">
                  <div className="autocomplete-wrappers col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12 mb-3 prd-3 pl-1  prm-3"></div>
                  <div className="autocomplete-wrappers col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12 mb-3 prd-3 pl-1  prm-3 ">
                    <Autocomplete
                      value={this.state.poValidationShipName}
                      items={this.state.EquipmentList}
                      getItemValue={(item) => item}
                      renderInput={(props) => {
                        return (
                          <input
                            className="form-control"
                            id="exampleFormControlInput1"
                            placeholder="Ship Name"
                            {...props}
                            style={{ border: "1px solid #ffffff" }}
                          />
                        );
                      }}
                      shouldItemRender={this.renderMovieTitle.bind(this)}
                      renderMenu={(item) => (
                        <div className="dropdowns">{item}</div>
                      )}
                      renderItem={(item, isHighlighted) => (
                        <div
                          className={`items ${isHighlighted ? "selected-items" : ""
                            }`}
                        >
                          {item}
                        </div>
                      )}
                      onChange={(e, field) =>
                        this.handleInputChanges(e, "poValidationShipName")
                      }
                      onSelect={(value) =>
                        this.handleSelectChange(value, "poValidationShipName")
                      }
                    />
                    <span
                      id="poValidationErrMsg"
                      style={{ color: "red" }}
                    ></span>
                  </div>
                  <div className="col-xl-2 col-lg-2 col-md-2 col-sm-6 col-6 px-1 px-1 mb-3">
                    <button
                      className="btn btn-primary txtside-btn txtht-btn blue w-100 btnclr"
                      type="submit"
                      onClick={() => this.SearchShipPOs(1)}
                    >
                      {" "}
                      Search{" "}
                    </button>
                  </div>
                  <div className="col-xl-2 col-lg-2 col-md-2 col-sm-6 col-6 px-1 px-1 mb-3">
                    <button
                      className="btn txtside-btn txtht-btn w-100 clearbtn clr-butn"
                      type="button"
                      onClick={() => this.ClearPoSearchField()}
                    >
                      <img
                        className="mb-1"
                        src={clear}
                        width={21}
                        height={21}
                      />{" "}
                      Clear{" "}
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {ShipPO && ShipPO.length ? (
              <div id="textbody">
                <ShipPOs
                  arraylist={ShipPO}
                  setUpdatedState={(value) => this.SearchShipPOs(value)}
                />
              </div>
            ) : this.state.initialSearch == 0 ? (
              <>
                <div className="mt-0 mb-4 ml-4 mr-4  cardBck row">
                  <div className="col-xl-12">
                    <h6 className="bold-count no-item-card f-size">No Ships</h6>
                  </div>
                </div>
                <div className="pb-1"></div>
              </>
            ) : null}
          </>
        ) : null}
        {this.state.isAwaitingMdAndSdoc ? (
          <>
            <div className="pt-3 px-2 mx-1 row">
              <div className="col-xl-4">
                <label className="label-card">Ships</label>
              </div>
              <div className="col-xl-8 my-auto">
                <div className="row pl-2 prd-4 mbm1rem">
                  <div className="autocomplete-wrappers col-xl-1 col-lg-0 col-md-0 col-sm-0 col-0 mb-3 prd-3 pl-1  prm-3"></div>
                  <div className="autocomplete-wrappers col-xl-4 col-lg-5 col-md-4 col-sm-12 col-12 mb-3 prd-3 pl-1  prm-3 ">
                    <Autocomplete
                      value={this.state.poValidationShipName}
                      items={this.state.EquipmentList}
                      getItemValue={(item) => item}
                      renderInput={(props) => {
                        return (
                          <input
                            className="form-control"
                            id="exampleFormControlInput1"
                            placeholder="Ship Name"
                            {...props}
                            style={{ border: "1px solid #ffffff" }}
                          />
                        );
                      }}
                      shouldItemRender={this.renderMovieTitle.bind(this)}
                      renderMenu={(item) => (
                        <div className="dropdowns">{item}</div>
                      )}
                      renderItem={(item, isHighlighted) => (
                        <div
                          className={`items ${isHighlighted ? "selected-items" : ""
                            }`}
                        >
                          {item}
                        </div>
                      )}
                      onChange={(e, field) =>
                        this.handleInputChanges(e, "poValidationShipName")
                      }
                      onSelect={(value) =>
                        this.handleSelectChange(value, "poValidationShipName")
                      }
                    />
                    <span id="awaitingErrMsg" style={{ color: "red" }}></span>
                  </div>
                  <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-6 px-1 px-1 mb-3">
                    <button
                      className="btn btn-primary txtside-btn txtht-btn blue w-100 btnclr"
                      type="submit"
                      onClick={() => this.downloadAwaitingExcel()}
                    >
                      {" "}
                      Export to Excel{" "}
                    </button>
                  </div>
                  <div className="col-xl-2 col-lg-2 col-md-2 col-sm-6 col-6 px-1 px-1 mb-3">
                    <button
                      className="btn btn-primary txtside-btn txtht-btn blue w-100 btnclr h-100"
                      type="submit"
                      onClick={() => this.SearchShipPOs(1)}
                    >
                      {" "}
                      Search{" "}
                    </button>
                  </div>
                  <div className="col-xl-2 col-lg-2 col-md-2 col-sm-6 col-6 px-1 px-1 mb-3">
                    <button
                      className="btn txtside-btn txtht-btn w-100 clearbtn clr-butn"
                      type="button"
                      onClick={() => this.ClearPoSearchField()}
                    >
                      <img
                        className="mb-1"
                        src={clear}
                        width={21}
                        height={21}
                      />{" "}
                      Clear{" "}
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {ShipPO && ShipPO.length ? (
              <ShipPOs
                arraylist={ShipPO}
                setUpdatedState={(value) => this.SearchShipPOs(value)}
              />
            ) : this.state.initialSearch == 0 ? (
              <>
                <div className="mt-0 mb-4 ml-4 mr-4  cardBck row">
                  <div className="col-xl-12">
                    <h6 className="bold-count no-item-card f-size">No Ships</h6>
                  </div>
                </div>
                <div className="pb-1"></div>
              </>
            ) : null}
          </>
        ) : null}
        {this.state.isIhmPart1 ? (
          <>
            <div className="pt-3 px-2 mx-1 row">
              <div className="col-xl-4">
                <label className="label-card">Ships</label>
              </div>
              <div className="col-xl-8 my-auto">
                <div className="row pl-2 prd-4 mbm1rem">
                  <div className="autocomplete-wrappers col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12 mb-3 prd-3 pl-1  prm-3"></div>
                  <div className="autocomplete-wrappers col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12 mb-3 prd-3 pl-1  prm-3 ">
                    <Autocomplete
                      value={this.state.poValidationShipName}
                      items={this.state.EquipmentList}
                      getItemValue={(item) => item}
                      renderInput={(props) => {
                        return (
                          <input
                            className="form-control"
                            id="exampleFormControlInput1"
                            placeholder="Ship Name"
                            {...props}
                            style={{ border: "1px solid #ffffff" }}
                          />
                        );
                      }}
                      shouldItemRender={this.renderMovieTitle.bind(this)}
                      renderMenu={(item) => (
                        <div className="dropdowns">{item}</div>
                      )}
                      renderItem={(item, isHighlighted) => (
                        <div
                          className={`items ${isHighlighted ? "selected-items" : ""
                            }`}
                        >
                          {item}
                        </div>
                      )}
                      onChange={(e, field) =>
                        this.handleInputChanges(e, "poValidationShipName")
                      }
                      onSelect={(value) =>
                        this.handleSelectChange(value, "poValidationShipName")
                      }
                    />
                    <span id="ihmPart1ErrMsg" style={{ color: "red" }}></span>
                  </div>
                  <div className="col-xl-2 col-lg-2 col-md-2 col-sm-6 col-6 px-1 px-1 mb-3">
                    <button
                      className="btn btn-primary txtside-btn txtht-btn blue w-100 btnclr"
                      type="submit"
                      onClick={() => this.SearchShipPOs(1)}
                    >
                      {" "}
                      Search{" "}
                    </button>
                  </div>
                  <div className="col-xl-2 col-lg-2 col-md-2 col-sm-6 col-6 px-1 px-1 mb-3">
                    <button
                      className="btn txtside-btn txtht-btn w-100 clearbtn clr-butn"
                      type="button"
                      onClick={() => this.ClearPoSearchField()}
                    >
                      <img
                        className="mb-1"
                        src={clear}
                        width={21}
                        height={21}
                      />{" "}
                      Clear{" "}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            {ShipPO && ShipPO.length ? (
              <ShipPOs
                arraylist={ShipPO}
                setUpdatedState={(value) => this.SearchShipPOs(value)}
              />
            ) : this.state.initialSearch == 0 ? (
              <>
                <div className="mt-0 mb-4 ml-4 mr-4  cardBck row">
                  <div className="col-xl-12">
                    <h6 className="bold-count no-item-card f-size">No Ships</h6>
                  </div>
                </div>
                <div className="pb-1"></div>
              </>
            ) : null}
          </>
        ) : null}
        {this.state.isIhmUpdate2 ? (
          <>
            <div className="pt-3 px-2 mx-1 row">
              <div className="col-xl-4">
                <label className="label-card">Ships</label>
              </div>
              <div className="col-xl-8 my-auto">
                <div className="row pl-2 prd-4 mbm1rem">
                  <div className="autocomplete-wrappers col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12 mb-3 prd-3 pl-1  prm-3"></div>
                  <div className="autocomplete-wrappers col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12 mb-3 prd-3 pl-1  prm-3 ">
                    <Autocomplete
                      value={this.state.poValidationShipName}
                      items={this.state.EquipmentList}
                      getItemValue={(item) => item}
                      renderInput={(props) => {
                        return (
                          <input
                            className="form-control"
                            id="exampleFormControlInput1"
                            placeholder="Ship Name"
                            {...props}
                            style={{ border: "1px solid #ffffff" }}
                          />
                        );
                      }}
                      shouldItemRender={this.renderMovieTitle.bind(this)}
                      renderMenu={(item) => (
                        <div className="dropdowns">{item}</div>
                      )}
                      renderItem={(item, isHighlighted) => (
                        <div
                          className={`items ${isHighlighted ? "selected-items" : ""
                            }`}
                        >
                          {item}
                        </div>
                      )}
                      onChange={(e, field) =>
                        this.handleInputChanges(e, "poValidationShipName")
                      }
                      onSelect={(value) =>
                        this.handleSelectChange(value, "poValidationShipName")
                      }
                    />
                    <span id="imhUpdatedErrMsg" style={{ color: "red" }}></span>
                  </div>
                  <div className="col-xl-2 col-lg-2 col-md-2 col-sm-6 col-6 px-1 px-1 mb-3">
                    <button
                      className="btn btn-primary txtside-btn txtht-btn blue w-100 btnclr"
                      type="submit"
                      onClick={() => this.SearchShipPOs(1)}
                    >
                      {" "}
                      Search{" "}
                    </button>
                  </div>
                  <div className="col-xl-2 col-lg-2 col-md-2 col-sm-6 col-6 px-1 px-1 mb-3">
                    <button
                      className="btn txtside-btn txtht-btn w-100 clearbtn clr-butn"
                      type="button"
                      onClick={() => this.ClearPoSearchField()}
                    >
                      <img
                        className="mb-1"
                        src={clear}
                        width={21}
                        height={21}
                      />{" "}
                      Clear{" "}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            {ShipPO && ShipPO.length ? (
              <ShipPOs
                arraylist={ShipPO}
                setUpdatedState={(value) => this.SearchShipPOs(value)}
              />
            ) : this.state.initialSearch == 0 ? (
              <>
                <div className="mt-0 mb-4 ml-4 mr-4  cardBck row">
                  <div className="col-xl-12">
                    <h6 className="bold-count no-item-card f-size">No Ships</h6>
                  </div>
                </div>
                <div className="pb-1"></div>
              </>
            ) : null}
          </>
        ) : null}
        {this.state.isShortClosed ? (
          <>
            <div className="pt-3 px-2 mx-1 row">
              <div className="col-xl-4">
                <label className="label-card">Ships</label>
              </div>
              <div className="col-xl-8 my-auto">
                <div className="row pl-2 prd-4 mbm1rem">
                  <div className="autocomplete-wrappers col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12 mb-3 prd-3 pl-1  prm-3"></div>
                  <div className="autocomplete-wrappers col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12 mb-3 prd-3 pl-1  prm-3 ">
                    <Autocomplete
                      value={this.state.poValidationShipName}
                      items={this.state.EquipmentList}
                      getItemValue={(item) => item}
                      renderInput={(props) => {
                        return (
                          <input
                            className="form-control"
                            id="exampleFormControlInput1"
                            placeholder="Ship Name"
                            {...props}
                            style={{ border: "1px solid #ffffff" }}
                          />
                        );
                      }}
                      shouldItemRender={this.renderMovieTitle.bind(this)}
                      renderMenu={(item) => (
                        <div className="dropdowns">{item}</div>
                      )}
                      renderItem={(item, isHighlighted) => (
                        <div
                          className={`items ${isHighlighted ? "selected-items" : ""
                            }`}
                        >
                          {item}
                        </div>
                      )}
                      onChange={(e, field) =>
                        this.handleInputChanges(e, "poValidationShipName")
                      }
                      onSelect={(value) =>
                        this.handleSelectChange(value, "poValidationShipName")
                      }
                    />
                    <span id="scErrMsg" style={{ color: "red" }}></span>
                  </div>
                  <div className="col-xl-2 col-lg-2 col-md-2 col-sm-6 col-6 px-1 px-1 mb-3">
                    <button
                      className="btn btn-primary txtside-btn txtht-btn blue w-100 btnclr"
                      type="submit"
                      onClick={() => this.SearchShipPOs(1)}
                    >
                      {" "}
                      Search{" "}
                    </button>
                  </div>
                  <div className="col-xl-2 col-lg-2 col-md-2 col-sm-6 col-6 px-1 px-1 mb-3">
                    <button
                      className="btn txtside-btn txtht-btn w-100 clearbtn clr-butn"
                      type="button"
                      onClick={() => this.ClearPoSearchField()}
                    >
                      <img
                        className="mb-1"
                        src={clear}
                        width={21}
                        height={21}
                      />{" "}
                      Clear{" "}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            {ShipPO && ShipPO.length ? (
              <ShipPOs
                arraylist={ShipPO}
                setUpdatedState={(value) => this.SearchShipPOs(value)}
              />
            ) : this.state.initialSearch == 0 ? (
              <>
                <div className="mt-0 mb-4 ml-4 mr-4  cardBck row">
                  <div className="col-xl-12">
                    <h6 className="bold-count no-item-card f-size">No Ships</h6>
                  </div>
                </div>
                <div className="pb-1"></div>
              </>
            ) : null}
          </>
        ) : null}

        {this.state.isShipsPendingTask ? (
          <>
            <div className="pt-3 px-2 mx-1 row">
              <div className="col-xl-4">
                <label className="label-card">Ships</label>
              </div>
              <div className="col-xl-8 my-auto">
                <div className="row pl-2 prd-4 mbm1rem">
                  <div className="autocomplete-wrappers col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12 mb-3 prd-3 pl-1  prm-3"></div>
                  <div className="autocomplete-wrappers col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12 mb-3 prd-3 pl-1  prm-3 ">
                    <Autocomplete
                      value={this.state.poValidationShipName}
                      items={this.state.EquipmentList}
                      getItemValue={(item) => item}
                      renderInput={(props) => {
                        return (
                          <input
                            className="form-control"
                            id="exampleFormControlInput1"
                            placeholder="Ship Name"
                            {...props}
                            style={{ border: "1px solid #ffffff" }}
                          />
                        );
                      }}
                      shouldItemRender={this.renderMovieTitle.bind(this)}
                      renderMenu={(item) => (
                        <div className="dropdowns">{item}</div>
                      )}
                      renderItem={(item, isHighlighted) => (
                        <div
                          className={`items ${isHighlighted ? "selected-items" : ""
                            }`}
                        >
                          {item}
                        </div>
                      )}
                      onChange={(e, field) =>
                        this.handleInputChanges(e, "poValidationShipName")
                      }
                      onSelect={(value) =>
                        this.handleSelectChange(value, "poValidationShipName")
                      }
                    />
                    <span
                      id="pendingShipErrMsg"
                      style={{ color: "red" }}
                    ></span>
                  </div>

                  <div className="col-xl-2 col-lg-2 col-md-2 col-sm-6 col-6 px-1 px-1 mb-3">
                    <button
                      className="btn btn-primary txtside-btn txtht-btn blue w-100 btnclr"
                      type="submit"
                      onClick={() => this.SearchShipPOs(1)}
                    >
                      {" "}
                      Search{" "}
                    </button>
                  </div>
                  <div className="col-xl-2 col-lg-2 col-md-2 col-sm-6 col-6 px-1 px-1 mb-3">
                    <button
                      className="btn txtside-btn txtht-btn w-100 clearbtn clr-butn"
                      type="button"
                      onClick={() => this.ClearPoSearchField()}
                    >
                      <img
                        className="mb-1"
                        src={clear}
                        width={21}
                        height={21}
                      />{" "}
                      Clear{" "}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            {ShipPO && ShipPO.length ? (
              <ShipPOs
                arraylist={ShipPO}
                setUpdatedState={(value) => this.SearchShipPOs(value)}
              />
            ) : this.state.initialSearch == 0 ? (
              <>
                <div className="mt-0 mb-4 ml-4 mr-4  cardBck row">
                  <div className="col-xl-12">
                    <h6 className="bold-count no-item-card f-size">No Ships</h6>
                  </div>
                </div>
                <div className="pb-1"></div>
              </>
            ) : null}
          </>
        ) : null}

        {this.state.TotalShip ? (
          <>
            <div className="row my-3 mx-2 pb-3">
              <div className="col-lg-12">
                <div className="panel-box">
                  <div
                    className="card MM-card-header m-auto"
                    style={{ backgroundColor: "white" }}
                  >
                    <div className="card-body">
                      <h5
                        className="card-title ml-2 mt-2"
                        style={{ color: "092a51" }}
                      >
                        All Ships
                      </h5>
                    </div>
                  </div>
                  <div className="search-filter-box">
                    <div className="row" style={{ paddingBottom: "12px" }}>
                      <div className="col-lg-6">
                        <label className="form-label">Ship Name</label>
                        <br></br>
                        <input
                          className="form-control"
                          type="text"
                          name="shipName"
                          placeholder="Ship Name"
                          onChange={(e) => this.handleShipInputChange(e)}
                          value={this.state.shipName}
                        ></input>
                        <span
                          id="totalShipErrMsg"
                          style={{ color: "red" }}
                        ></span>
                      </div>

                      <div className="col-lg-6">
                        <label className="form-label"></label>
                        <br></br>
                        <div
                          className="mt-3 search-btn-col"
                          style={{ textAlign: "end" }}
                        >
                          <button
                            className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                            type="submit"
                            onClick={() => this.SearchShips(1)}
                          >
                            {" "}
                            Search{" "}
                          </button>
                          <button
                            className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                            type="button"
                            onClick={() => this.ClearShipSearchField()}
                          >
                            {" "}
                            Clear{" "}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {MMPLShipList ? (
              <MMPLShipCard
                arraylist={MMPLShipList.data}
                pageSize={MMPLShipList.pagination.pageSize}
                totalRecords={
                  MMPLShipList.pagination.totalcount
                    ? MMPLShipList.pagination.totalcount
                    : 0
                }
                setUpdatedState={(value) => this.SearchShips(value)}
              />
            ) : this.state.initialSearch == 0 ? (
              <>
                <div className="mt-0 mb-4 ml-4 mr-4  cardBck row">
                  <div className="col-xl-12">
                    <h6 className="bold-count no-item-card f-size">No Ships</h6>
                  </div>
                </div>{" "}
              </>
            ) : null}
          </>
        ) : null}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    showSidePane: state.SidePanReducer.sidePan || false,
    arraylist: state.SidePanReducer.arraylist,
    MDDeleteSuccess: state.SidePanReducer.MDDeleteSuccess,
    isMDSearch: state.SidePanReducer.isMDSearch,
    MDSearchData: state.SidePanReducer.MDSearchData,
    ClientShipDetails: state.SidePanReducer.ClientShipDetails,
    //BY BALU MOORTHI
    shipMMPLCount: state.MMPLDashboardReducer.ShipMMPLCount,
    shipMMPLDetail: state.MMPLDashboardReducer.shipMMPLDetail || {},
    shipMMPLSearchResult: state.MMPLDashboardReducer.MMPLShipSearchResult || [],
    shipMMPLInfo: state.MMPLDashboardReducer.MMPLShipInfo || {},
    showMMPLDetailsPane: state.SidePanReducer.ShowMMPLDetails || false,
    MMPLSidePanCollectDocs: state.MMPLDashboardReducer.MMPLSidePanCollectDocs,
    MMPLShipList: state.MMPLDashboardReducer.MMPLShipList,
    poSearchResult: state.MMPLDashboardReducer.MMPLPOShipSearchResult,
    mDocSearchResults: state.MMPLDashboardReducer.MMPLMdocShipSearchResult,
    IHMSearchResults: state.MMPLDashboardReducer.MMPLIHMShipSearchResult,
    ShortClosedSearchResults:
      state.MMPLDashboardReducer.MMPLShortClosedShipSearchResult,
    ShipPO: state.MMPLDashboardReducer.ShipPOs,
    SearchResult: state.MMPLDashboardReducer.SearchResult,
    ClientPOs: state.MMPLDashboardReducer.ClientPOs || [],

    ShipNameList: state.UserManageReducer.ShipNameList,
    clientSearchResult: state.MMPLDashboardReducer.clientSearchResult,
    ClientList: state.MMPLDashboardReducer.ClientList,
    ShipList: state.MMPLDashboardReducer.getshipByEmail,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(MMPLDashboard);
